import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=6e332174&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./gallery.css?vue&type=style&index=0&id=6e332174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e332174",
  null
  
)

export default component.exports